import { Header, Container, Title, Footer, AuthBox } from "../../../components/index";
import styles from "./style.module.css";
import okkologo from "../../../assets/okkoadminlogo.svg";
import userlogo from "../../../assets/userlogowhite.svg";
import menu from "../../../assets/menu.svg";
import { useNavigate, useParams } from "react-router-dom";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { errorMessage } from "../../../helpers/toast";
import { useEffect, useState } from "react";
import { getFormattedDate } from "../../../helpers/year";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { currencyFormatter } from "../../../helpers/currency";

const AdminTotalMoney = () => {
  const { isletmeId } = useParams();
  const axiosClient = useAxiosClient();

  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const startDay = startDate.getDate().toString().padStart(2, "0");
  const startMonth = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const startYear = startDate.getFullYear();

  const endDay = endDate.getDate().toString().padStart(2, "0");
  const endMonth = (endDate.getMonth() + 1).toString().padStart(2, "0");
  const endYear = endDate.getFullYear();

  const startDateFormatted = startYear + "-" + startMonth + "-" + startDay;
  const endDateFormatted = endYear + "-" + endMonth + "-" + endDay;

  const [totalMoney, setTotalMoney] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getTotalMoney();
  }, [startDate, endDate]);

  const getTotalMoney = async () => {
    try {
      const response = await axiosClient.get(
        `/superuser/get-ciro-by-date/start-date=${startDateFormatted}&end-date=${endDateFormatted}&filter=day`
      );
      if (response.status === 200) {
        setTotalMoney(response?.data?.data);
      }
    } catch (error) {
      errorMessage("İşletmeler getirilirken bir hata oluştu.");
    }
  };

  return (
    <div className="md:grid grid-rows-layoutAuth">
      <Header className="bg-primary" okkoLogo={okkologo} userIcon={userlogo} menuIcon={menu} profileLink={"/profil"} homeLink={"/admin"} />
      <Container className={styles.container}>
        <Title className={styles.midTitle}>Toplam Ciro</Title>

        <div className="flex items-center gap-6 mb-6">
          <div className="flex flex-col items-center">
            <h5 className="text-base">Başlama Tarihi</h5>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              className="border rounded-md text-center py-1 text-xl"
              dateFormat={"dd-MM-yyyy"}
              maxDate={new Date()}
            />
          </div>

          <div className="flex flex-col items-center">
            <h5 className="text-base">Bitiş Tarihi</h5>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              className="border rounded-md text-center py-1 text-xl"
              dateFormat={"dd-MM-yyyy"}
              maxDate={new Date()}
            />
          </div>
        </div>

        <AuthBox className={styles.authBox1}>
          <div className="flex flex-col items-start gap-4">
            <div className="flex justify-between gap-6 text-xl w-72">
              <p>Toplam Nakit:</p>
              <p className="font-bold">{currencyFormatter(parseFloat(totalMoney?.total_cash)) + " TL"}</p>
            </div>
            <div className="flex justify-between gap-6 text-xl w-72">
              <p>Toplam Kredi:</p>
              <p className="font-bold">{currencyFormatter(parseFloat(totalMoney?.total_credit)) + " TL"}</p>
            </div>
            <div className="flex justify-between gap-6 text-xl w-72">
              <p>Toplam:</p>
              <p className="font-bold">{currencyFormatter(parseFloat(totalMoney?.total_money)) + " TL"}</p>
            </div>
          </div>
        </AuthBox>
      </Container>

      <Footer />
    </div>
  );
};

export default AdminTotalMoney;
